<script>
import Layout from "@/views/layouts/main.vue";
import DetailSpecificDates from "@/views/pages/project/schedule/detail_specific_dates.vue";
import DetailRegular from "@/views/pages/project/schedule/detail_regular.vue";
import apiEndpoints from "@/services/apiEndpoints";
import sweetAlert from "@/mixins/sweetAlert";
import appConfig from "@/app.config.json";

export default {
  name: 'RouteDetailScheduleByWorkReservation',
  page: {
    title: "スケジュール詳細",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    DetailSpecificDates,
    DetailRegular,
  },
  mixins: [sweetAlert],
  data() {
    return {
      response: null,
    };
  },
  created() {
    this.getWorkReservation();
  },
  methods: {
    async getWorkReservation () {
      const {status, code, data} = await this.$http.get(apiEndpoints.detail_work_reservation_with_work_order(this.workReservationId))
      if (!status) {
        return this.errorToast(data.message);
      }
      this.response = data.result;
    },
  },
  computed: {
    isRegularReservation() {
      if (! this.response) return false;

      if (this.$route.query.zz_reservation_frequency_type_id === this.$constant.zzReservationFrequencyTypeId.date_specific) {
        return false;
      }

      return !! this.response.regularly_reservation_start_date
    },
    workReservationId() {
      return this.$route.params.work_reservation_id;
    },
  }
};
</script>

<template>
  <div>
    <DetailSpecificDates
      v-if="response && !isRegularReservation"
      :work-reservation="response"
    />
    <DetailRegular
      v-if="response && isRegularReservation"
      :work-reservation="response"
    />
  </div>
</template>

<style scoped lang="scss">
.scroll-area {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
}
.work-instruction-content,
.reservation-contents,
.reservation-reception {
  .title {
    font-size: 16px;
    font-weight: 700;
  }
}
.work-instruction-content {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }
  .block-1 {
    a {
      text-decoration: underline !important;
      color: #495057;
    }
  }
  .block-3 {
    gap: 30px;
    .number-of-workers {
      margin-right: 20px;
      span {
        margin-left: 20px;
      }
    }
  }
  .block-4 {
    .vehicle-list {
      margin-left: 48px;
    }
  }
}
.reservation-contents {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }
  .block-5,
  .block-6 {
    span {
      margin-left: 10px;
    }
  }
}
.reservation-reception {
  .work-detail {
    .infomations {
      div > span {
        margin-left: 5px;
      }
      .waste-work-name {
        margin-left: 10px;
      }
      .waste-type, .manifesto {
        margin-left: 20px;
      }
    }
  }
  .transport-destination {
    margin-left: 35px;
  }
}
.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}
.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 6px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}
.custom-radio-group .radio-group {
  margin-left: unset;
}
.multiselect {
  width: 60%;
}
.button-fixed-custom {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 10;
  margin-bottom: 20px;
}
</style>
